import {Izvestaj} from "../../../komponente/izvestaj/Izvestaj";
import podaci from './podaci.json';

export default class NemackiIzvestaj extends Izvestaj {

  constructor() {
    super(podaci);
  }

}



// WEBPACK FOOTER //
// ./src/hronologija/1941/08-11/Izvestaj.js